import { defineMessages } from 'react-intl';

export const messages: {
	moreDetail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newLearning: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newRisk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newDecision: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moreDetail: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.additional-notes.more-detail.non-final',
		defaultMessage: 'More detail',
		description: 'Title for the update note section when no summary provided',
	},
	newLearning: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.additional-notes.new-learning.non-final',
		defaultMessage: 'New learning',
		description:
			'Default placeholder heading shown for a new learning highlight item in the project status update additional notes section',
	},
	newRisk: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.additional-notes.new-risk.non-final',
		defaultMessage: 'New risk',
		description:
			'Default placeholder heading shown for a new risk highlight item in the project status update additional notes section',
	},
	newDecision: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.additional-notes.new-decision.non-final',
		defaultMessage: 'New decision',
		description:
			'Default placeholder heading shown for a new decision highlight item in the project status update additional notes section',
	},
});
